import { getGenericSettings } from '../Services/portal';
import { useBizQuery } from './useBizQuery';

export const QUERYKEY_GENERICSETTINGS = 'GENERICSETTINGS';

export const useGetGenericSettingsQuery = (type: string, keys: string[]) =>
	useBizQuery([QUERYKEY_GENERICSETTINGS, type, keys], () => getGenericSettings(type, keys));

export const useGetGenericSettings = (type: string, keys: string[]) => {
	const { data } = useGetGenericSettingsQuery(type, keys);
	return data;
};
